export const ADMIN_ROUTES = {
    ROOT: '/admin-panel',
    LOGIN: {
        PATH: 'login',
        FULL: '/login',
    },
    TEAM: {
        PATH: 'team',
        FULL: '/admin-panel/team',
    },
    PROGRAMS: {
        PATH: 'programs',
        FULL: '/admin-panel/programs',
    },
};
